/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';

/**
 * A React component that wraps a legacy view; ensuring that the legacy view's render()
 * is only called when the component mounts and not every time the React component renders.
 */
class LegacyComponent extends Component {

	componentDidMount() {
		const { item: view = {} } = this.props;
		if (!view.render || typeof view.render !== 'function') {
			return;
		}

		view.render();
	}

	componentWillUnmount() {
		const { item: view = {} } = this.props;
		if (!view.remove || typeof view.remove !== 'function') {
			return;
		}

		view.remove();
	}

	render() {
		if (!this.props.item) {
			return;
		}
		return <div className={this.props.className} ref={node => node && this.onNodeRef(node)} />;
	}

	onNodeRef(node) {
		const { item: view = {} } = this.props;

		if (view.$el && view.$el.length) {
			node.appendChild(view.$el[0]);
		}
	}

}

LegacyComponent.propTypes = {
	item: PropTypes.object,
	className: PropTypes.string
};

export default LegacyComponent;



// WEBPACK FOOTER //
// ./src/js/components/legacy/LegacyComponent.js